import React from 'react';

export default [
  {
    question: 'Что я могу получить в наборе?',
    answer: `В каждый праздничный набор входит книга Вероники Сидоровой «Новые письма к тебе», пакет, калька и открытка. 
    А также любимые изделия, девайсы, аксессуары и бьюти-продукты Вероники, которые распределены по разным видам наборов. 
    Стоимость наборов варьируется от 7.000 до 646.000 рублей.
    <br/>
    <b>Виды наборов:</b>
    <ol>
    <li>L’Oreal, шампунь (100 мл.) и маска (75 мл.) из линейки Pro Longer для восстановления волос по длине, 100 мл., Clarins, тушь, wonder volume mascara xxl.</li>
    <li>L’Oreal, шампунь (100 мл.) и маска (75 мл.) из линейки Pro Longer для восстановления волос по длине, 100 мл</li>
    <li>Л’Окситан, масло для душа увлажняющее миндальное (75 мл), Clarins, тушь, wonder volume mascara xxl, платочек Otvet.co «С чистого листа».</li>
    <li>Clarins, тушь, wonder volume mascara xxl, платочек Otvet.co «С чистого листа»</li>
    <li>Primrose, шелковая маска для сна в мешочке и гребень в кружевном мешочке, Л’Окситан, масло для душа увлажняющее миндальное (75 мл).</li>
    <li>Кофейник и сахарница из лимитированной серии Императорского фарфорового завода для Otvet.co.</li>
    <li>Bork, перкуссионный массажер со сменными насадками для разных зон тела.</li>
    <li>Present&Simple, кашемировый или хлопковый свитер, в размере M или L.</li>
    <li>Zarina, Вязаный шерстяной лонгслив с мохером в размере М или L; Вязаный лонгслив с открытыми плечами из шерсти в размере М или L; Черный бомбер с блестками в размере М или L; Вельветовая рубашка из хлопка в размере М или L.</li>
    <li>Primrose, шелковая пижама в размере M или L.</li>
    <li>Косметический дорожный набор для ухода за кожей лица Institute Esthederm: Osmoclean крем дезинкрустант для глубокого очищения, 15 мл.; Сыворотка для продления молодости кожи Age Proteom, 5 мл.; Eau Cellulaire Увлажняющий крем, 10 мл.; Фирменная косметичка.</li>
    <li>The Row, сумка Margaux.</li>
    </ol>
    `

  },
  {
    question: 'Как распределяются наборы?',
    answer: 'Наборы распределяются без специально заданного порядка и распределяются случайным образом.'
  },
  {
    question: 'Как осуществляется упаковка и перевозка изделий?',
    answer: 'Мы стараемся надежно упаковывать и бережно перевозить все грузы.',
  },
  {
    question: 'Когда отправят мой заказ?',
    answer: 'Заказы передаются в службу доставки по мере их готовности.'
  },
  {
    question: 'Сроки доставки по городам России?',
    answer: '5-8 дней с момента передачи заказа в курьерскую службу.'
  },
  {
    question: 'Перечень стран СНГ, куда осуществляется доставка?',
    answer: 'Мы отправляем изделия только по России.'
  },
  {
    question: 'Какая транспортная компания осуществляет доставку?',
    answer: 'Доставку заказов осуществляет компания <a href="www.cdek.ru" target="_blank">СДЭК</a>. В случае возникновения непредвиденной ситуации, которая влечет за собой увеличение сроков доставки или цены, ваш заказ может быть перенаправлен на доставку компанией Почта России.'
  },
  {
    question: 'Может ли кто-то другой забрать мой заказ при самовывозе?',
    answer: 'Оформив самовывоз, вам необязательно забирать заказ лично. Вы можете направить к нам курьера любой службы доставки. Для забора заказа курьеру нужно будет назвать вашу фамилию и номер заказа'
  },
  {
    question: 'Есть ли возможность самостоятельно забрать заказ?',
    answer: 'Для покупателей online-магазина существует услуга самовывоза. Заказ Вы можете забрать самостоятельно из нашего офиса в Москве, который находится по адресу: 4-ая Тверская-Ямская 22, Пространство "Ответ".'
  },
  {
    question: 'Адрес интернет-магазина в Москве и график работы?',
    answer: '4-я Тверская-Ямская, 22. Вход в магазин со двора. Ориентир - салон красоты Beauty Center. Слева металлические ворота с калиткой. На домофоне наберите 99 или 98, калитка откроется. Дальше идите по двору направо по указателям ОТВЕТ.\n' +
      'Режим работы: пн-пт 10:00 - 20:00, сб-вс 11:00 - 15:00.'
  },
  {
    question: 'Где искать подробную информацию об изделиях?',
    answer: 'Вся дополнительная информация по изделиям, представленным в онлайн-магазине, размещена в карточке товара, под фотографиями изделия.'
  },
  {
    question: 'Где искать информацию о моем заказе?',
    answer: 'Информация о Ваших заказах отображена в личном кабинете в разделе <a href="https://otvet.co/items" target="_blank">"Мои Покупки"</a>. Дополнительно информация о заказе направляется на почту, указанную в момент оформления покупки. После того как заказ передается в курьерскую службу, в Вашем личном кабинете появляется трек-номер, по которому Вы можете отслеживать доставку на сайте <a href="www.cdek.ru" target="_blank">www.cdek.ru</a>'
  },
  {
    question: 'Как я могу оплатить свой заказ?',
    answer: 'Оплата изделий производится банковской картой на сайте проекта «Ответ». Для оплаты из-за границы или картой нероссийского банка, пожалуйста, напишите нам в WhatsApp: <a href="https://wa.me/79851234432" target="_blank">+7 985 123-44-32</a>'
  },
  {
    question: 'Какие сроки доставки по Москве и Санкт-Петербургу?',
    answer: '3-4 дня с момента передачи заказа в курьерскую службу.'
  },
  {
    question: 'Кому я могу задать дополнительные вопросы?',
    answer: 'Мы будем рады ответить на любые Ваши вопросы по телефону или почте. Мы на связи с 10:00 до 18:00 (по московскому времени):\n' +
      '<a href="tel://+7 985 123-44-32">+7 985 123-44-32</a>'
  }
]
